// Wraps an async function so identical calls made while one is still running
// share that one call instead of each starting their own request. Several
// parts of the dashboard ask for the same device's data at the same moment
// (the page and its tiles, a mount and a selection restore), and without this
// each fired its own copy.
//
// Only calls in flight are shared: once a call settles it is forgotten, so the
// next one - a Refresh, a poll, a later visit - goes to the network again.
// Calls match when their arguments do, compared as JSON.
export const shareInFlight = (fn, keyOf = (...args) => JSON.stringify(args)) => {
  const pending = new Map();
  return (...args) => {
    const key = keyOf(...args);
    if (pending.has(key)) return pending.get(key);
    const promise = Promise.resolve()
      .then(() => fn(...args))
      .finally(() => pending.delete(key));
    pending.set(key, promise);
    return promise;
  };
};
